import { useMemo } from 'react';
import { AutocompleteInput, required, useDataProvider } from 'react-admin';
import { useQuery } from '@tanstack/react-query';
import type { CrmDataProvider } from '@/providers/types';

interface CardAssigneeInputProps {
    /** Pre-selected assignee (non-superusers default to themselves in create). */
    defaultValue?: number;
}

export const CardAssigneeInput = ({ defaultValue }: CardAssigneeInputProps) => {
    const dataProvider = useDataProvider<CrmDataProvider>();
    const { data: assignees = [] } = useQuery({
        queryKey: ['cardAssignees'],
        queryFn: () => dataProvider.getCardAssignees(),
        staleTime: 5 * 60 * 1000, // 5 minutes
    });

    const choices = useMemo(() => assignees, [assignees]);

    return (
        <AutocompleteInput
            source="assigned_to"
            label="Assign to"
            choices={choices}
            optionText="name"
            optionValue="id"
            defaultValue={defaultValue}
            validate={required('Assignee is required')}
            isLoading={!assignees}
            sx={{ width: '100%' }}
        />
    );
};

CardAssigneeInput.displayName = 'CardAssigneeInput';
